export default __webpack_public_path__ + "static/media/O-132.bf57acc4.png";